import styled from 'styled-components';
import {injectAdaptive, injectSafeTop} from 'ui/theme';

export const Wrapper = styled.div`
  position: fixed;
  z-index: 25;
  overflow-x: hidden;
  overflow-y: scroll;
  background: ${(p) => p.theme.dark};
  -webkit-overflow-scrolling: touch;

  ${(p) => p.theme.fitContainerStyle}
  ${injectAdaptive('top', ['61px', '61px', '66px', '71px', '71px'])}
  ${injectSafeTop('margin')}

  .center {
    margin-top: -3px;
  }

  &.is-enter-active,
  &.is-exit-active {
    ${(p) => p.theme.defaultAnimationStyle}
  }

  &.is-enter,
  &.is-exit-active {
    transform: translateX(-100vw);
    opacity: 0;
  }

  &.is-enter-active {
    transform: translateX(0);
    opacity: 1;
  }
`;
